/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SLAType } from "~/models";

export function displaySlaType(value: string) {
  switch (value) {
    case SLAType.TTA:
      return "TTA";
    case SLAType.TTR:
      return "TTR";
    case SLAType.RANGE:
      return "Range";
    default:
      return "-";
  }
}
